import { Server, Cpu, Cloud, Mail, ShieldCheck, type LucideIcon } from "lucide-react";

export type IconKey = "vps" | "dedicated" | "cloud" | "email" | "security";

export const categoryIcon: Record<IconKey, LucideIcon> = {
  vps: Server,
  dedicated: Cpu,
  cloud: Cloud,
  email: Mail,
  security: ShieldCheck,
};
